import React from "react";
import { payCheck } from "../../assets";
import { Link } from "react-router-dom";

const PaymentSuccess = () => {
  return (
    <div className="pay-success">
      <img src={payCheck} alt="" />
      <div>
        <p>Payment Successfull</p>
        <small>Thank you for your booking. We will contact you soon.</small>
        <Link to="/">Back to Home</Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
